import { Box, IconButton } from "@mui/material"

import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"

import {
  DashBoardIcon,
  Drawer,
  DrawerHeader,
  customTheme,
  UserManagementIcon,
  MetricBlueprintIcon,
  PnLBlueprintIcon,
  CustomerManagementIcon,
  MetricGoalsIcon,
  MetricsIcon,
  OpportunityIcon,
  PnLReportingIcon,
  ProvidesIcon,
  ResourceBudgetIcon,
  OfficeHuddleIcon,
  ComplianceIcon,
  AuditIcon,
  Provider_Production_SummaryIcon,
  HelpCenterIcon,
  ProntoAiIcon,
} from "./Atom"
import DrawerItem from "./DrawerItem"
import MenuIcon from "@mui/icons-material/Menu"

import ProntoLogo from "../../../assets/images/ProntoLogo.png"
import { permissions } from "../../../config/constants"

const NavDrawer = (props: any) => {
  const { open, styles, theme, isSelected, handleDrawerClose } = props

  return (
    <Drawer
      variant="permanent"
      open={open}
      PaperProps={{
        style: {
          backgroundColor: "#031741",
          border: "none",
        },
      }}
    >
      <DrawerHeader sx={{ bgcolor: "white", minHeight: "10vh !important" }}>
        <Box
          sx={{
            marginRight: "20px",
          }}
        >
          <h4
            className={styles.LoginHeadingText}
            style={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* <ProntoLogoIcon /> &nbsp;PRONTO */}
            <img height={"30px"} src={ProntoLogo} alt="" />
          </h4>
          {/* <h5 className={styles.LoginSubHeadingText}>Advisory</h5> */}
        </Box>

        <IconButton onClick={handleDrawerClose}>
          {theme.direction === "rtl" ? <ChevronRightIcon /> : <MenuIcon />}
        </IconButton>
      </DrawerHeader>

      <Box
        sx={{
          flex: 1,
          height: "100%",
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        <DrawerItem
          open={open}
          isSelected={isSelected}
          navLinkEnd={`/users`}
          disabled={false}
          item={"users"}
          itemTitle={`User Management`}
          DisplayIcon={UserManagementIcon}
          willCollapseSidebar={false}
          handleDrawerClose={handleDrawerClose}
          perm={permissions.VIEW_USER_MANAGEMENT}
        />
        <DrawerItem
          open={open}
          isSelected={isSelected}
          navLinkEnd={`/customer`}
          disabled={false}
          item={"customer"}
          itemTitle={`Customer Management`}
          DisplayIcon={CustomerManagementIcon}
          willCollapseSidebar={false}
          handleDrawerClose={handleDrawerClose}
          perm={permissions.VIEW_CUSTOMER_MANAGEMENT}
        />
        <DrawerItem
          open={open}
          isSelected={isSelected}
          navLinkEnd={`/metric-bm`}
          disabled={false}
          item={`metric`}
          itemTitle={`Metric Blueprint Management`}
          DisplayIcon={MetricBlueprintIcon}
          willCollapseSidebar={true}
          handleDrawerClose={handleDrawerClose}
          perm={permissions.VIEW_METRIC_BLUEPRINT_MANAGEMENT}
        />
        <DrawerItem
          open={open}
          isSelected={isSelected}
          navLinkEnd={`/`}
          disabled={false}
          item={"dashboard"}
          itemTitle={`Dashboard`}
          DisplayIcon={DashBoardIcon}
          willCollapseSidebar={false}
          handleDrawerClose={handleDrawerClose}
          perm="bypass"
        />
        <DrawerItem
          open={open}
          isSelected={isSelected}
          navLinkEnd={`/huddle`}
          disabled={false}
          item={"officeHuddle"}
          itemTitle={`Office Huddle`}
          DisplayIcon={OfficeHuddleIcon}
          willCollapseSidebar={true}
          handleDrawerClose={handleDrawerClose}
          perm={permissions.VIEW_HUDDLE}
        />
        <DrawerItem
          open={open}
          isSelected={isSelected}
          navLinkEnd={`/pronto-ai`}
          disabled={false}
          item={"prontoAi"}
          itemTitle={`Pronto AI`}
          DisplayIcon={ProntoAiIcon}
          willCollapseSidebar={true}
          handleDrawerClose={handleDrawerClose}
          perm={permissions?.VIEW_PRONTO_AI}
          standOut={true}
        />
        <DrawerItem
          open={open}
          isSelected={isSelected}
          navLinkEnd={`/opportunity-dashboard`}
          disabled={false}
          item={`opportunityDashboard`}
          itemTitle={`Opportunity`}
          DisplayIcon={OpportunityIcon}
          willCollapseSidebar={true}
          handleDrawerClose={handleDrawerClose}
          perm={permissions.VIEW_OPPORTUNITY_DASHBOARD}
        />
        <DrawerItem
          open={open}
          isSelected={isSelected}
          navLinkEnd={`/metric-g`}
          disabled={false}
          item={`metricGoal`}
          itemTitle={`Metric Goals`}
          DisplayIcon={MetricGoalsIcon}
          willCollapseSidebar={true}
          handleDrawerClose={handleDrawerClose}
          perm={permissions.VIEW_GOALS}
        />
        <DrawerItem
          open={open}
          isSelected={isSelected}
          navLinkEnd={`/metric-o`}
          disabled={false}
          item={`metricOpportunity`}
          itemTitle={`Metrics`}
          DisplayIcon={MetricsIcon}
          willCollapseSidebar={true}
          handleDrawerClose={handleDrawerClose}
          perm={permissions.VIEW_METRICS}
        />
        <DrawerItem
          open={open}
          isSelected={isSelected}
          navLinkEnd={`/providers`}
          disabled={false}
          item={"providers"}
          itemTitle={`Providers`}
          DisplayIcon={ProvidesIcon}
          willCollapseSidebar={true}
          handleDrawerClose={handleDrawerClose}
          perm={permissions.VIEW_PROVIDERS}
        />
        <DrawerItem
          open={open}
          isSelected={isSelected}
          navLinkEnd={`/doctor-compensation`}
          disabled={false}
          item={"doctorCompensation"}
          itemTitle={`Doctor Compensation`}
          DisplayIcon={ComplianceIcon}
          willCollapseSidebar={true}
          handleDrawerClose={handleDrawerClose}
          perm={permissions.VIEW_DOCTOR_COMPENSATION}
        />
        <DrawerItem
          open={open}
          isSelected={isSelected}
          navLinkEnd={`/p-and-l-reporting`}
          disabled={false}
          item={"pnlReporting"}
          itemTitle={`P&L Reporting`}
          DisplayIcon={PnLReportingIcon}
          willCollapseSidebar={true}
          handleDrawerClose={handleDrawerClose}
          perm={permissions.VIEW_PNL_REPORT}
        />
        <DrawerItem
          open={open}
          isSelected={isSelected}
          navLinkEnd={`/p-and-l-budget`}
          disabled={false}
          item={"pnlBudget"}
          itemTitle={`P&L Budget`}
          DisplayIcon={PnLBlueprintIcon}
          willCollapseSidebar={true}
          handleDrawerClose={handleDrawerClose}
          perm={permissions.VIEW_PNL_BUDGET}
        />
        <DrawerItem
          open={open}
          isSelected={isSelected}
          navLinkEnd={`/resource-budget`}
          disabled={false}
          item={"resourceBudget"}
          itemTitle={`Resource Budget`}
          DisplayIcon={ResourceBudgetIcon}
          willCollapseSidebar={true}
          handleDrawerClose={handleDrawerClose}
          perm={permissions.VIEW_RESOURCE_BUDGET}
        />
      </Box>
    </Drawer>
  )
}

export default NavDrawer
